import { fetchCompanyEntities } from './companyEntitiesActions';

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Create async thunks for fetching data with error handling
export const getCompanyEntities = createAsyncThunk(
  'GET_COMPANY_ENTITIES',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCompanyEntities();

      if (response.status !== 200) {
        // Handle non-200 responses by returning a custom error payload
        return rejectWithValue({
          status: response.status,
          error: response.data?.error || 'Failed to fetch company entities',
        });
      }

      return response.data; // Success, return the data
    } catch (error) {
      // Handle unexpected errors (e.g., network issues)
      return rejectWithValue({
        status: error.response?.status || 500,
        error:
          error.message ||
          'Unknown error occurred while fetching company entities',
      });
    }
  }
);

const initialState = {
  companyEntities: [],
  companyEntitiesColumns: [],
};

export const companyEntitiesSlice = createSlice({
  name: 'companyEntitiesPage',
  initialState,
  reducers: {
    setCompanyEntities: (state, action) => {
      state.companyEntities = action.payload;
    },
    setCompanyEntitiesColumns: (state, action) => {
      state.companyEntitiesColumns = action.payload;
    },
  },
});

// Export actions
export const { setCompanyEntities, setCompanyEntitiesColumns } =
  companyEntitiesSlice.actions;

// Export the reducer
export default companyEntitiesSlice.reducer;
